import axios from "axios";
import {
    Event
} from "../models/event";

import {
    Status
} from "../models/status";

class EventWebservice {

    /** 
     * Fetch the newest event
     */
    public async getNewestEvent(): Promise<Event> {
        return await axios.get('/events/newestEvent').then(function (response) {
            let newestEvent:Event = response.data
            return Promise.resolve(newestEvent)
        }).catch(function (error) {
            return Promise.reject([])
        })
    }

    /**
     *  store the event 
     *
     * @param text event text
     * @param status_id event status id
     * @param push Push notification True Or False
     */
    public store(event: Event) {
        return axios.post("/admin/events/store", {
            text: event.text,
            status_id: event.status.id,
            push: event.push,
        })
    }

}

export const eventWebservice = new EventWebservice();


// WEBPACK FOOTER //
// ./src/webservices/event.ts